const addressFields = [
  {
    field: 'addressTypeName',
    title: 'Address Type',
    cell: 'navigation',
    width: 100,
    hidden: false,
  },
  {
    field: 'companyName',
    title: 'Company Name',
    width: 200,
    hidden: false,
  },
  {
    field: 'name',
    title: 'Name',
    width: 200,
    hidden: false,
  },
  {
    field: 'address1',
    title: 'Line 1',
    width: 150,
    hidden: false,
  },
  {
    field: 'address2',
    title: 'Line 2',
    width: 150,
    hidden: false,
  },
  {
    field: 'address3',
    title: 'Line 3',
    width: 150,
    hidden: false,
  },
  {
    field: 'city',
    title: 'City',
    width: 150,
    hidden: false,
  },
  {
    field: 'state',
    title: 'State',
    width: 50,
    hidden: false,
  },
  {
    field: 'zipCode',
    title: 'Postal Code',
    width: 50,
    hidden: false,
  },
  {
    field: 'countryCode',
    title: 'Country Code',
    width: 50,
    hidden: false,
  },
  {
    field: 'country',
    title: 'Country',
    width: 150,
    hidden: false,
  },
  {
    field: 'contactName',
    title: 'Contact Name',
    width: 100,
    hidden: false,
  },
  {
    field: 'isDefault',
    title: 'Is Default',
    cell: 'checkMark',
    width: 50,
    hidden: false,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
];

export default addressFields;
